import React from "react";
import { TouchableOpacity, Text, StyleSheet, View, ViewStyle, StyleProp } from "react-native";

import { useAppTheme } from "../../design-system/ThemeProvider";
import { COLORS } from "../../theme/colors";

interface PrimaryButtonProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  title,
  onPress,
  disabled,
  style,
}) => {
  const { colors } = useAppTheme();

  return (
    <TouchableOpacity
      style={style}
      onPress={onPress}
      activeOpacity={0.85}
      disabled={disabled}
      data-oid="6dbcrhw"
    >
      <View
        style={[
          styles.button,
          {
            backgroundColor: colors.primary,
          },
          disabled && [styles.disabled, { backgroundColor: COLORS.buttonDisabled }],
        ]}
      >
        <Text style={[styles.text, { color: colors.onPrimary }]} data-oid="luaniej">
          {title}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 32,
    alignItems: "center",
    marginVertical: 8,
  },
  text: {
    fontWeight: "700",
    fontSize: 18,
  },
  disabled: {
    backgroundColor: COLORS.buttonDisabled,
  },
});

export default PrimaryButton;
